import { VisitorResponseType } from "../enums/Enum";
import PhoneCountryData from "./PhoneContryData";
import PhoneValidator from "./PhoneValidator";

/**
 * A phone validator handler, facilitate phone validation functionality
 */
const PhoneValidationHandler = {
    phone: null,
    inputField: null,
    invalidPhoneNumberMessage: '',
    phoneCountryData: null,
    shouldEmptyInvalidInputOnTyping: false, // for live input validation in contact info feature
    addPhonePrefixNumber() {
        const me = this;
        if (!me.phoneCountryData) {
            // if country not supported by apexchat.
            me.phoneCountryData = PhoneCountryData.OTHER;
            return;
        }
        if (me.inputField.value === '') {
            me.inputField.value = me.phoneCountryData.phonePrefix;
        }
    },
    removePhonePrefixNumber(cb) {
        const me = this;
        if (me.lastMessage && me.lastMessage.visitorResponseType === VisitorResponseType.Phone) {
            // if we do not apply this condition it will remove the visitor message when agent send another quick message
            if (me.inputField.value === me.phoneCountryData.phonePrefix) {
                me.inputField.value = '';
            }
            me.inputField.removeEventListener('focus', cb);
        }
    },
    getInvalidMessageText() {
        if (this.phoneCountryData.name !== 'OTHER') {
            // if validation is based on country code
            return `Please enter a valid ${this.phoneCountryData.name} phone number.`;
        }
        return 'Please enter a valid phone number (1 555-555-5555)';
    },
    validate(phone) {
        this.phone = phone;
        const validator = Object.create(PhoneValidator);
        validator.phoneCountryData = this.phoneCountryData;
        validator.phone = this.phone;

        const validate = validator.validate();
        if (!validate) {
            if (!this.shouldEmptyInvalidInputOnTyping) {
                // Applying a check so that phone input field won't get erased on every keyup validation (contact info feature live validation - CHAT-9603)
                this.inputField.value = '';
            }
            this.addPhonePrefixNumber();
        }
        return validate;
    }
};
export default PhoneValidationHandler;
